import { Edit, PlusOne } from '@mui/icons-material';
import { Button, FormControl, Grid, IconButton, Dialog, TextField, Typography, FormLabel } from '@mui/material'
import React, { useState } from 'react'
import PropTypes from 'prop-types';
import formDataToObj from '../../utils/formDataToObj';
import Category from '../../services/db/category';
import fileUpload from '../../services/fileUpload';
import { useContext } from 'react';
import { InfoContext } from '../../services/Context/Info/context';

function AddService({ data = {} }) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState((data?.subcategory?.length || 0) + 1);
  const [info, setInfo] = useState(data);
  const { data: { categoryData }, setData } = useContext(InfoContext)
  const handleChange = async e => {
    if (e.target.files?.[0] instanceof File) {
      fileUpload(e.target.files[0], (url) => {
        setInfo(prev => ({ ...prev, [e.target.name]: url }))
      })
    }
    else setInfo(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }
  const handleAdd = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    const prm = await formDataToObj(info)
    new Category().addCategory(prm).then((r) => {
      setCount(1);
      setInfo({});
      setOpen(false)
      if (prm.id) {
        const ind = categoryData.findIndex(el => el.id === prm.id)
        if (ind !== -1) {
          let c = categoryData.map(((el, _id) => (_id === ind ? prm : el)))
          setData(p => ({ ...p, categoryData: c }))
        }
      }
      else setData(p => ({ ...p, categoryData: [...categoryData, { ...prm, id: r }] }))
    })
  }
  return (
    <>
      {!data.id ?
        <Button
          color='secondary'
          variant='contained'
          onClick={() => setOpen(true)}
        >
          Add Category
        </Button> :
        <IconButton onClick={() => setOpen(true)}>
          <Edit />
        </IconButton>
      }
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        sx={{ justifyContent: 'center', alignItems: 'center' }}
      >
        <Grid container maxWidth={'md'} sx={{ backgroundColor: 'white' }} spacing={2} padding={2}>
          <Grid item xs={12}>
            <Typography>Add Category</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Photo' size='small' fullWidth>
              <FormLabel>Photo</FormLabel>
              <TextField
                size='small'
                name="photo"
                aceept='image/*'
                fullWidth
                onChange={handleChange}
                type='file'
                placeholder='Choose image'
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Category' size='small' fullWidth>
              <FormLabel>Category</FormLabel>
              <TextField
                size='small'
                name="category"
                value={info?.category}
                fullWidth
                onChange={handleChange}
                type='text'
                placeholder='Enter Your category name'
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl title='Sub Category' size='small' fullWidth>
              <FormLabel>Subcategory</FormLabel>
              <Grid container spacing={2}>
                {Array(count).fill(0).map((el, id) => (
                  <>
                    <Grid item xs={11}>
                      <TextField
                        size='small'
                        name={`subcategory[${id}]`}
                        key={el}
                        value={info?.subcategory?.[id]}
                        fullWidth
                        onChange={handleChange}
                        type='text'
                        placeholder='Enter subcategory name'
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton onClick={() => setCount(prev => prev + 1)}>
                        <PlusOne />
                      </IconButton>
                    </Grid>
                  </>
                ))}
              </Grid>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button variant='contained' color='primary' onClick={handleAdd}>Submit</Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  )
}

AddService.propTypes = {
  data: PropTypes.shape({
    subcategory: PropTypes.array.isRequired,
  }).isRequired,
};

export default AddService